import * as React from 'react';

import { isCourserian } from 'js/lib/user';

import NotFound from 'bundles/promo-template/components/NotFound';
import { DOMAINS } from 'bundles/promo-template/constants/navigation';
import { PromoTemplateContext } from 'bundles/promo-template/contexts/PromoTemplateContext';
import { PromoTemplateDomainContext } from 'bundles/promo-template/contexts/PromoTemplateDomainContext';

const PromoTemplatePageGuard: React.LegacyFunctionComponentWithChildren = ({ children }) => {
  const { domain } = React.useContext(PromoTemplateDomainContext);
  const { isPreview } = React.useContext(PromoTemplateContext);

  if ((isPreview || domain === DOMAINS.dev) && !isCourserian()) {
    return <NotFound />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default PromoTemplatePageGuard;
